module.exports = __webpack_public_path__ + "img/people.5ab085a.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/indicateurs-icons/people.svg
// module id = oMgb
// module chunks = 7